import React from "react";
import Blog_50_8 from "../component/Blog_50_8";
function Blog_50_8_container() {
  return <Blog_50_8 />;
}

export default Blog_50_8_container;
